"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var SVG_1 = __importDefault(require("./SVG"));
var Icon = styled_components_1.default(SVG_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    polygon {\n        fill: ", ";\n    }\n"], ["\n    polygon {\n        fill: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorControlIcon;
});
exports.default = (function (props) { return (react_1.default.createElement(Icon, __assign({}, props, { viewBox: "0 0 7 12", width: "7px", height: "12px" }),
    react_1.default.createElement("polygon", { points: "0 8 3.5 12 7 8 4 8 4 0 3 0 3 8 0 8" }))); });
var templateObject_1;
//# sourceMappingURL=Desc.js.map